export const ARTICLES_FEED = `articles/feed`;
export const ARTICLES = `articles`;
export const ARTICLES_BY_SLUG = (id) => `articles/${id}`;
